import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRealtimeParticipants } from '../../hooks/useRealtime'
import { Ticker } from '../../components/overlay/Ticker'

export function TickerPage() {
  const [searchParams] = useSearchParams()
  const raceId = searchParams.get('race') || ''

  const { participants } = useRealtimeParticipants(raceId)

  const bestLaps = useMemo(() => {
    return participants
      .filter((p) => p.best_lap_time !== null)
      .sort((a, b) => (a.best_lap_time || 0) - (b.best_lap_time || 0))
      .slice(0, 10)
      .map((p) => ({
        id: p.id,
        pilotName: p.pilot_name,
        boatNumber: p.boat_number,
        boatColor: p.boat_color,
        lapTime: p.best_lap_time || 0,
      }))
  }, [participants])

  return (
    <div className="w-full h-screen bg-transparent">
      <Ticker items={bestLaps} title="TODAY'S BEST TIMES" />
    </div>
  )
}
